import { Category as CTCategory } from './commercetools'

export enum CategoryNameLocation {
  InsideBanner = 'inside-banner',
  BelowBanner = 'below-banner',
}

export interface Category extends Pick<CTCategory, 'id' | 'key' | 'name'> {
  description?: string
  orderHint?: string
  thumbnail?: {
    src: string
    altText: string
    width: number
    height: number
  }
  url: string
  totalProducts?: number
  children?: Category[]
  tier?: number
}
